var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobbliIconFooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 80,
    viewBox: "0 0 89 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1128_134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.4367 35.8138C88.4367 60.2138 68.7627 79.9998 44.5009 79.9998C20.2392 79.9998 0.565186 60.2138 0.565186 35.8138C0.565186 30.9347 4.5009 26.9766 9.35234 26.9766C14.2038 26.9766 18.1395 30.9347 18.1395 35.8138C18.1395 50.4556 29.942 62.3254 44.5009 62.3254C59.0599 62.3254 70.8624 50.4556 70.8624 35.8138C70.8624 30.9347 74.7981 26.9766 79.6496 26.9766C84.501 26.9766 88.4367 30.9347 88.4367 35.8138Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6505 18.8088C84.8151 18.8088 89.0018 14.5982 89.0018 9.40416C89.0018 4.21012 84.8151 -0.000488281 79.6505 -0.000488281C74.4858 -0.000488281 70.2991 4.21012 70.2991 9.40416C70.2991 14.5982 74.4858 18.8088 79.6505 18.8088Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.35138 18.8088C14.516 18.8088 18.7028 14.5982 18.7028 9.40416C18.7028 4.21012 14.516 -0.000488281 9.35138 -0.000488281C4.18676 -0.000488281 0 4.21012 0 9.40416C0 14.5982 4.18676 18.8088 9.35138 18.8088Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1128_134"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 89,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobbliIconFooter);
export default __webpack_public_path__ + "static/media/jobbli-icon-footer.e86664d26cdea6135a90b5e7174b5840.svg";
export { ForwardRef as ReactComponent };